import { useOnClickOutside } from '@/hooks/useOnClickOutSide';
import { useState, useRef, useCallback } from 'react';
import clsx from 'clsx';
import * as ViewModel from '@/core/presenter/viewModel';
import { useStores } from '@/stores';

interface IProps {
  isWritting: boolean;
  selectedAsset: ViewModel.IAsset | undefined;
  onChangeSelectedAssetValue: (assetType: ViewModel.AssetType) => void;
}

const SelectAssetsCombobox = ({ isWritting, selectedAsset, onChangeSelectedAssetValue }: IProps) => {
  const { userStore } = useStores();
  const [visible, setVisible] = useState<boolean>(false);
  const ref = useRef<HTMLDivElement>(null);
  useOnClickOutside(ref, () => setVisible(false));

  const handleAssetSelect = (assetType: ViewModel.AssetType) => {
    setVisible(false);
    onChangeSelectedAssetValue(assetType);
  };

  const getCurrentAssetInfo = useCallback(() => {
    return selectedAsset?.symbol === 'TRX'
      ? {
          balance: userStore.myAsset?.trxAsset?.balance,
          name: userStore.myAsset?.trxAsset?.name,
          symbol: userStore.myAsset?.trxAsset?.symbol,
          icon: userStore.myAsset?.trxAsset?.iconPath,
        }
      : {
          balance: userStore.myAsset?.tokenAsset?.balance,
          name: userStore.myAsset?.tokenAsset?.name,
          symbol: userStore.myAsset?.tokenAsset?.symbol,
          icon: userStore.myAsset?.tokenAsset?.iconPath,
        };
  }, [selectedAsset?.symbol, userStore.myAsset]);

  const currentAsset = getCurrentAssetInfo();

  return (
    <div
      className={clsx('asset-dropdown', !isWritting && 'hidden')}
      style={{ display: isWritting ? 'flex' : 'none' }}
      ref={ref}
    >
      <label>자산:</label>
      <div className="selected-asset" onClick={() => setVisible(!visible)}>
        <img src={currentAsset.icon} alt={currentAsset.name} />
        <div className="text-wrap">
          <span id="selectedAssetName">{currentAsset.name}</span>
          <span id="selectedAssetBalance">
            잔액: {currentAsset.balance} {currentAsset.symbol}
          </span>
        </div>
        <i className={clsx('bi', visible ? 'bi-chevron-up' : 'bi-chevron-down', 'dropdown-icon')}></i>
      </div>
      {visible && (
        <ul className={clsx('asset-options', !visible && 'hidden')} style={{ display: visible ? 'block' : 'none' }}>
          <li onClick={() => handleAssetSelect(ViewModel.AssetType.DBS)}>
            <img src={userStore.myAsset?.tokenAsset?.iconPath} alt={userStore.myAsset?.tokenAsset?.name} />
            <div>
              <p>{userStore.myAsset?.tokenAsset?.name}</p>
              <span>
                잔액: {userStore.myAsset?.tokenAsset?.balance} {userStore.myAsset?.tokenAsset?.symbol}
              </span>
            </div>
          </li>
          <li onClick={() => handleAssetSelect(ViewModel.AssetType.TRX)}>
            <img src={userStore.myAsset?.trxAsset?.iconPath} alt={userStore.myAsset?.trxAsset?.name} />
            <div>
              <p>{userStore.myAsset?.trxAsset?.name}</p>
              <span>
                잔액: {userStore.myAsset?.trxAsset?.balance} {userStore.myAsset?.trxAsset?.symbol}
              </span>
            </div>
          </li>
        </ul>
      )}
    </div>
  );
};

export default SelectAssetsCombobox;
